import { Color } from '@kite-js/theme-types';

const orange: Color = {
    50: '#feead3',
    100: '#ffb583',
    200: '#ff8938',
    300: '#ff6800',
    400: '#cc5300',
    500: '#953d00',
};

export default orange;
